module.exports = __webpack_public_path__ + "static/media/Home Page Trouser.9df9168e.png";